import { Box } from '@mui/material';
import { Draggable } from 'react-beautiful-dnd';
import { CostTypeDto } from '../../common/PricePrgClient';
import { StrictModeDroppable } from '../../common/StrictModeDroppable';
import CostType from './CostType';
type Props = {
    costTypes: CostTypeDto[];
};

export function CostTypeList({ costTypes }: Props) {
    return (
        <StrictModeDroppable droppableId="CostTypesList" type="droppableCost">
            {provided => (
                <Box
                    component="div"
                    sx={{ padding: '8px', marginLeft: '8px' }}
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                >
                    {costTypes.map((costType, index) => (
                        <Draggable
                            key={costType.value}
                            draggableId={'costType_' + index}
                            index={costType.value!}
                        >
                            {providedDrag => (
                                <CostType key={costType.value} provided={providedDrag} costType={costType} />
                            )}
                        </Draggable>
                    ))}
                    {provided.placeholder}
                </Box>
            )}
        </StrictModeDroppable>
    );
}
